import React, {  Component } from 'react';

export default class AvailQtyEtaDescriptionsOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('AvailQtyEtaDescriptionsOverlayDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="actionDescriptionsOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Avail Qty / ETA</h2>
                    <div className="scroll-height-action-description">
    					<table className="dataTable">
    						<tbody>
    							<tr>
    								<td> 
                                        <b>Avail Qty:</b> The number available to arrive on the Requested Delivery Date selected.<br/>
                                        <em className="block" style={{marginTop: '.5rem', fontStyle: 'normal'}}>For SDS Orders, this will never show a quantity greater than your order quantity.  To see the full quantity available from the serving ADC, go to the Cart or select ADC Truckload as the shipping method.</em><br/>
                                        <b>ETA:</b> If the full quantity is not available by the Requested Delivery Date, the date shown is when the full quantity will be available to arrive at your location.<br/><br/>
                                        <b>6+ mos:</b> Model is currently in production, but demand exceeds all planned supply.  “6+ mos.” indicates that we cannot provide an exact ETA date. The system estimate for availability under these conditions is greater than 6 months from today.<br/><br/>
                                        <b>FP:</b> Model is past the final production date and there is no more supply being produced. “FP” indicates that the model cannot be supplied from the serving warehouse and should be replaced with the new model or deleted from the order.
                                    </td>
    							</tr>
    						</tbody>
    					</table>
                    </div>
            	</div>
			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/availQtyEtaDescriptionsOverlayDialog.js